import { BlockchainType } from '@shared/types/services/enums';
import { detectAddressType } from './detectAddressType';
var AddressError;
(function (AddressError) {
  AddressError["INVALID_ADDRESS"] = "Please double check your address, it could not be validated";
  AddressError["EVM_GOT_SVM"] = "Expected EVM address but received Solana.";
  AddressError["EVM_GOT_MOVE"] = "Expected EVM address but received Move.";
  AddressError["SVM_GOT_EVM"] = "Expected Solana address but received EVM.";
  AddressError["SVM_GOT_MOVE"] = "Expected Solana address but received Move.";
  AddressError["MOVE_GOT_EVM"] = "Expected Move address but received EVM.";
  AddressError["MOVE_GOT_SVM"] = "Expected Move address but received Solana.";
})(AddressError || (AddressError = {}));
const getSpecificError = (expectedType, detectedType) => {
  if (!detectedType) {
    return AddressError.INVALID_ADDRESS;
  }
  const errorMap = {
    [`${BlockchainType.EVM}-${BlockchainType.SVM}`]: AddressError.EVM_GOT_SVM,
    [`${BlockchainType.EVM}-${BlockchainType.MOVE}`]: AddressError.EVM_GOT_MOVE,
    [`${BlockchainType.SVM}-${BlockchainType.EVM}`]: AddressError.SVM_GOT_EVM,
    [`${BlockchainType.SVM}-${BlockchainType.MOVE}`]: AddressError.SVM_GOT_MOVE,
    [`${BlockchainType.MOVE}-${BlockchainType.EVM}`]: AddressError.MOVE_GOT_EVM,
    [`${BlockchainType.MOVE}-${BlockchainType.SVM}`]: AddressError.MOVE_GOT_SVM
  };
  const errorKey = `${expectedType}-${detectedType}`;
  return errorMap[errorKey] || AddressError.INVALID_ADDRESS;
};
export const validateWithdrawRecipient = (recipient, expectedType) => {
  // First detect what type of address was provided
  const detectedType = detectAddressType(recipient);
  // If we couldn't detect any valid type, it's an invalid address format
  if (!detectedType) {
    return {
      result: false,
      error: getSpecificError(expectedType, detectedType)
    };
  }
  // If the detected type matches the expected type, it's valid
  if (detectedType === expectedType) {
    return {
      result: true
    };
  }
  // If we got here, we have a type mismatch
  return {
    result: false,
    error: getSpecificError(expectedType, detectedType)
  };
};